module.exports = __webpack_public_path__ + "media/images/illustrations/corner-2-875f8638a1a5cef0ad7df52ba1f75f1d.png";